import { TreeViewNodeModule } from './tree-view-node/tree-view-node.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewComponent } from './tree-view.component';



@NgModule({
  declarations: [
    TreeViewComponent,
  ],
  imports: [
    CommonModule,

		TreeViewNodeModule,
  ],
	exports: [
		TreeViewComponent,
	],
})
export class TreeViewModule { }
